import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElRow, ElCol } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'content-header',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElRow), {
    class: "content-header",
    gutter: 10
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElCol), { span: 7 }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("职位名称")
        ])),
        _: 1
      }),
      _createVNode(_unref(ElCol), { span: 9 }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("工作地点")
        ])),
        _: 1
      }),
      _createVNode(_unref(ElCol), { span: 8 }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("学历要求")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})